export enum GenreTypeString {
	M = 'Masculin',
	F = 'Féminin',
	N = 'Neutre'
}

export enum GenreType {
	'M' = 'M',
	'F' = 'F',
	'N' = 'N'
}
